import Immutable from 'immutable';
import {
  SET_MODULE_PROGRESS_FOR_COURSE,
  START_FETCH_MODULE_PROGRESS_FOR_COURSE,
} from './actions';

const DEFAULT_STATE = Immutable.fromJS({
  /*
  coursePath: {
    isLoading: bool,
    moduleList: [module]
  */
});

export function ModuleProgress(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case START_FETCH_MODULE_PROGRESS_FOR_COURSE: {
      const { coursePath } = action;
      return state.setIn([coursePath, 'isLoading'], true);
    }
    case SET_MODULE_PROGRESS_FOR_COURSE: {
      const { coursePath, moduleProgress } = action;
      /*
       * Note: moduleProgress must be the array of modules as returned by the server
       * as this is the display order used by the module display component
       */

      return state.set(
        coursePath,
        Immutable.fromJS({
          isLoading: false,
          moduleList: moduleProgress,
        })
      );
    }
    default: {
      return state;
    }
  }
}
